// extracted by mini-css-extract-plugin
export var planDisclaimer = "AnnualPlanCard_planDisclaimer__OGYFD";
export var planSubTitle = "AnnualPlanCard_planSubTitle__Vk5IP";